// NoteContainer.js
import React from "react";
import Note from "../Note/Note";
import "./NoteContainer.css";

function NoteContainer(props) {
  // Check if props.notes is an array
  if (!Array.isArray(props.notes)) {
    return <div>No Notes present.</div>;
  }

  const reversedNotes = [...props.notes].reverse(); // Reverse the notes array to maintain the correct order

  return (
    <div className="note-container">
      <h1 className="text-2xl mt-2 mb-2 font-bold">Notes</h1>
      <div className="note-container_notes custom-scroll">
        {reversedNotes.map((note, index) => (
          <Note
            key={note.stickyNotesId}
            note={note}
            deleteNote={props.deleteNote}
            updateText={props.updateText}
            index={index} // Pass the index to the Note component
          />
        ))}
      </div>
    </div>
  );
}


export default NoteContainer;
